import { Link } from "@inertiajs/react"
import { UsersRound } from "lucide-react"
import { useTranslation } from "react-i18next"

import { EmptyState } from "@/components/empty-state"
import { Button } from "@/components/ui/button"
import { candidatesPath } from "@/routes"

/**
 * OKS-25 F9 — Crew empty state.
 *
 * Surfaces when `is_empty === true` (BE-derived from
 * `EXISTS` over the unfiltered active relation — distinct from
 * "filters returned zero rows" which is `<CrewListNoResultsPanel>`).
 *
 * Per UX Spec §States — Empty:
 *   - lucide `UsersRound` icon
 *   - heading: "No creators in your crew yet"
 *   - body: "Approve candidates and they'll show up here once they sign up."
 *   - CTA: "Browse candidates" → `candidatesPath()` (OKS-17)
 *   - Filter bar HIDDEN in this state (page-level concern, F10)
 *   - Stats strip still renders with `0` / `—` / `—`
 *
 * Locked testids:
 *   - `crew-list-empty` — section root
 *   - `crew-list-empty-cta` — "Browse candidates" CTA target
 */
export function CrewListEmptyState() {
  const { t } = useTranslation()
  return (
    <div data-testid="crew-list-empty">
      <EmptyState
        icon={UsersRound}
        title={t("crew.list.empty.heading")}
        description={t("crew.list.empty.body")}
        actions={
          <Button asChild data-testid="crew-list-empty-cta">
            <Link href={candidatesPath()}>{t("crew.list.empty.cta")}</Link>
          </Button>
        }
      />
    </div>
  )
}
